// extracted by mini-css-extract-plugin
export default {"user__orderAside":"UserOrderDetailsAside_user__orderAside__CO8Nw"};